import { styled } from '@material-ui/core/styles';

import { Select } from 'ui-components/v2/Select';
import { down } from 'utils/breakpointHelpers';

export const SelectStyled = styled(Select)({
  width: '280px',
  height: '42px',

  [down('md')]: {
    width: '220px',
  },

  [down('sm')]: {
    width: '110px',
  },
});
